import { formatWithCommas } from "common/utils"
import React, { useEffect, useState } from "react"
import { Bar } from "react-chartjs-2"
import { useTranslation } from "react-i18next"
import { Card, CardBody, CardTitle, Col, Row, Table } from "reactstrap"
import Select from "components/Shared/TranslatedSelect"

const SalesByProducts = ({ estoreDashboardData, getTotal, barOptions }) => {
  const {
    t,
    i18n: { language },
  } = useTranslation()

  const [ordersData, setOrdersData] = useState({ labels: [], datasets: [] })
  const [amountData, setAmountData] = useState({ labels: [], datasets: [] })
  const [selectedProduct, setSelectedProduct] = useState(null)

  useEffect(() => {
    if (estoreDashboardData?.salesByProducts?.length) {
      const labels = estoreDashboardData.salesByProducts.map(item =>
        language === "en" ? item.name : item.nameAr
      )

      const totalOrders = estoreDashboardData.salesByProducts.map(
        item => item.totalQuantity
      )

      const totalAmount = estoreDashboardData.salesByProducts.map(
        item => item.totalAmount
      )

      setOrdersData({
        labels,
        datasets: [
          {
            label: t("Total Orders"),
            data: totalOrders,
            backgroundColor: "rgba(54, 162, 235, 0.6)",
          },
        ],
      })

      setAmountData({
        labels,
        datasets: [
          {
            label: t("Total Amount"),
            data: totalAmount,
            backgroundColor: "#00E396",
          },
        ],
      })
    }
  }, [estoreDashboardData, language])

  return (
    <>
      <Row>
        <Col lg={12}>
          <Card>
            <CardBody>
              <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center mb-3">
                <CardTitle>{t("E-Store Sales Summary By Product")}</CardTitle>
                {estoreDashboardData?.salesByProducts?.length > 0 && (
                  <Select
                    styles={{ width: "100px" }}
                    value={selectedProduct}
                    isClearable
                    placeholder={t("Filter By Product")}
                    options={estoreDashboardData?.salesByProducts?.map(
                      item => ({
                        value: item.itemId,
                        label: language === "en" ? item.name : item.nameAr,
                      })
                    )}
                    onChange={option => setSelectedProduct(option)}
                  />
                )}
              </div>
              {estoreDashboardData?.salesByProducts?.length === 0 ? (
                <p className="text-center my-3">{t("No data found")}</p>
              ) : (
                <div className="table-responsive">
                  <Table hover>
                    <thead className="table-light">
                      <tr>
                        <th>{t("Item")}</th>
                        <th>{t("Quantity")}</th>
                        <th>{t("Orders")}</th>
                        <th>{t("Order %")}</th>
                        <th>{t("Amount")}</th>
                        <th>{t("Amount %")}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {estoreDashboardData?.salesByProducts
                        ?.filter(item => {
                          if (!selectedProduct) return true
                          if (item.itemId === selectedProduct?.value)
                            return true
                          return false
                        })
                        ?.map((item, key) => {
                          return (
                            <tr key={key}>
                              <td>
                                {language === "en" ? item?.name : item?.nameAr}
                              </td>
                              <td>{formatWithCommas(item?.totalQuantity)}</td>
                              <td>
                                {formatWithCommas(
                                  item?.totalOrders?.toFixed(2)
                                )}
                              </td>
                              <td>
                                {formatWithCommas(
                                  item?.orderPercentage?.toFixed(2)
                                )}
                              </td>
                              <td>
                                {formatWithCommas(
                                  item?.totalAmount?.toFixed(2)
                                )}
                              </td>
                              <td>
                                {formatWithCommas(
                                  item?.amountPercentage?.toFixed(2)
                                )}
                              </td>
                            </tr>
                          )
                        })}
                    </tbody>
                    {!selectedProduct && (
                      <tfoot className="table-light">
                        <tr>
                          <th>{t("Total")}</th>

                          <th>
                            {formatWithCommas(
                              getTotal(
                                estoreDashboardData?.salesByProducts,
                                "totalQuantity"
                              )
                            )}
                          </th>
                          <th>
                            {formatWithCommas(
                              getTotal(
                                estoreDashboardData?.salesByProducts,
                                "totalOrders"
                              )?.toFixed(2)
                            )}
                          </th>
                          <th>
                            {formatWithCommas(
                              getTotal(
                                estoreDashboardData?.salesByProducts,
                                "orderPercentage"
                              )?.toFixed(2)
                            )}
                          </th>
                          <th>
                            {formatWithCommas(
                              getTotal(
                                estoreDashboardData?.salesByProducts,
                                "totalAmount"
                              )?.toFixed(2)
                            )}
                          </th>
                          <th>
                            {formatWithCommas(
                              getTotal(
                                estoreDashboardData?.salesByProducts,
                                "amountPercentage"
                              )?.toFixed(2)
                            )}
                          </th>
                        </tr>
                      </tfoot>
                    )}
                  </Table>
                </div>
              )}
            </CardBody>
          </Card>
        </Col>
      </Row>

      <Row>
        <Col lg={12}>
          <Card>
            <CardBody>
              <CardTitle>{t("Sales By Product Quantity")}</CardTitle>
              <Bar
                width={550}
                height={180}
                data={ordersData}
                options={barOptions}
              />
            </CardBody>
          </Card>
        </Col>
      </Row>

      <Row>
        <Col lg={12}>
          <Card>
            <CardBody>
              <CardTitle>{t("Sales By Product Amount")}</CardTitle>
              <Bar
                width={550}
                height={180}
                data={amountData}
                options={barOptions}
              />
            </CardBody>
          </Card>
        </Col>
      </Row>
    </>
  )
}

export default SalesByProducts
